<template>
  <div class="result-container">
    <h3>🔗 URL Final Generada</h3>
    <div class="url-box">
      <input type="text" :value="url" readonly id="finalUrl" />
      <button class="gradient-button" @click="copiar">📋 Copiar</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: String
  },
  methods: {
    copiar() {
      const input = document.getElementById("finalUrl");
      input.select();
      document.execCommand("copy");
    }
  }
}
</script>
